<template>
    <div :class="layout == 'FTQA' ? 'ftqa-dropdown px-5 pb-5 mb-10': ''">
        <template v-if="layout == 'FTDescription'">
            <v-container>
                <v-expansion-panels style="z-index: unset">
                    <v-expansion-panel>
                        <v-expansion-panel-header>
                            <v-row align="center" no-gutters>
                                <v-col cols="2" >
                                    <div class="montserrat responsive-text text-center font-weight-medium">
                                        {{FTDNumber}}
                                    </div>
                                </v-col>
                                <v-col cols="8">
                                    <div class="montserrat text-center" :class="$vuetify.breakpoint.smAndUp ? 'h4' : 'h5'"
                                        @focusout="onEditableChange('label')"
                                        :contenteditable="editableContent"
                                        @paste="filterPastedContent"
                                        v-html='this.FTDDialog'
                                    >
                                    </div>
                                </v-col>
                                <v-col cols="2" class="text-right">
                                    <i class="bx bx-plus bx-lg description-plus-icon"></i>
                                </v-col>
                            </v-row>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content class="text-center">
                            <v-btn v-if="item.image == null" dense small @click="uploadImage">Upload Image</v-btn>
                            <v-img class="dropdown-img" v-else max-height="300px" max-width="300px" contain :src="item.image"></v-img>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </v-container>
        </template>

        <v-expansion-panels accordion flat :class="styles.class" v-else>
            <v-expansion-panel>
                <v-expansion-panel-header :class="styles.header">
                    {{ styles.label }}
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <div :style="{ color: styles.data.color }" :class="styles.data.class"
                        @focusout="onEditableChange('data')"
                        :contenteditable="editableContent"
                        @paste="filterPastedContent"
                        v-html="item.data"
                    ></div>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
    </div>
</template>

<script>

export default {
    props: ["item", "styles", "indexes", "label"],
    computed: {
        FTDDialog () {
            var content, contentTitle, contentKorean
            content = this.item.label.split("<br>")
            content = content.map(function (item) {
                return item.replace(/<[^>]*>/g, "")
            })
            contentKorean = content[1]
            contentTitle = content[0]

            var splitText = contentTitle.replace(/&nbsp;/g, " ").split(" ")
            splitText = splitText.filter(function (item) {
                return item != ""
            })

            splitText.shift()
            contentTitle = splitText.join(" ")

            content[0] = "<span style='font-size: min(6vw, 1em);' class='font-weight-medium'>" + contentTitle + "</span>"
            content[1] = "<span style='font-size:0.6em'>" + contentKorean + "</span>"

            const parsedText = content.join("<br>")
            return parsedText
        },

        FTDNumber () {
            var content
            var splitText
            content = this.item.label.split("<br>")
            content = content.map(function (item) {
                return item.replace(/<[^>]*>/g, "")
            })
            splitText = content[0].replace(/&nbsp;/g, " ").split(" ")
            splitText = splitText.filter(function (item) {
                return item != ""
            })

            return splitText[0]
        }
    },
    methods: {
        onEditableChange (type) {
            this.columnEditableData("dropdown", this.indexes, type)
        },
        uploadImage () {
            this.$emit("uploadImage", true)
        }

    }
}
</script>

<style scoped>
.qanda-panel {
  border: 3px solid #dfe7fd !important;
}
.description-plus-icon {
    font-weight: bold;
    color: #fe7938;
}

.dropdown-img {
    margin: 0 auto;
}

.responsive-text{
    font-size: min(6vw, 2em);
    line-height: 1.5;
}

.ftqa-dropdown{
    border:  1px solid #dfe7fd;
    border-width: 0px 3px 3px 3px;
}

</style>
